// src/services/stockBalanceService.js
import ApiService from './api'

/**
 * Get the negative stock report for a branch
 * @param {string} branchId - Branch ID
 * @returns {Promise<Object>} - API response with negative stock data
 */
export const getNegativeStockReport = async (branchId) => {
  const response = await ApiService.get('/stock-balance/negative-report', {
    branchId,
  })
  return response
}

/**
 * Adjust product stock (daily balance count)
 * @param {Object} params
 * @param {string} params.branchId
 * @param {string} params.productId
 * @param {number} params.actualCount
 * @returns {Promise<Object>} - API response
 */
export const adjustProductStock = async ({ branchId, productId, actualCount }) => {
  const response = await ApiService.post('/stock-balance/adjust-product', {
    branchId,
    productId,
    actualCount,
  })
  return response
}

/**
 * Adjust raw material stock (daily balance count)
 * @param {Object} params
 * @param {string} params.branchId
 * @param {string} params.rawMaterialId
 * @param {number} params.actualCount
 * @returns {Promise<Object>} - API response
 */
export const adjustRawMaterialStock = async ({ branchId, rawMaterialId, actualCount }) => {
  const response = await ApiService.post('/stock-balance/adjust-raw-material', {
    branchId,
    rawMaterialId,
    actualCount,
  })
  return response
}

export default {
  getNegativeStockReport,
  adjustProductStock,
  adjustRawMaterialStock,
}
